import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { landingServices } from "src/app/landing/Services/landing.service";
import { Constant } from "src/app/shared/Constants/constant";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
})
export class FooterComponent implements OnInit {
  RouterClass!: string;
  IsLogin!: boolean;
  Year: number = new Date().getFullYear();
  ClientType!:string;
  ConstantClient!:string;
  CompanyName:string=environment.CompanyName;
  constructor(private router: Router,private landingServices: landingServices) {
  }

  async ngOnInit() 
  {
    this.IsLogin =await this.landingServices.showFooter();
    this.ClientType = environment.ClientName;
    this.ConstantClient = Constant.Virtusa;
  }
}
